import React from "react";
 import UploadBomFile from "../../components/Upload/UploadBomFile";

function UploadBom({ setPageHeader }) {
  setPageHeader("Upload Bom");
  return (
    <div>
      <UploadBomFile />
      {/* <StablePrime
        url="/textapi"
        data={{ dn: "StableImage1" }}
        identity="StableImage"
      /> */}
    </div>
  );
}

export default UploadBom;
